import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import RouteSeo from "./seo/Seo";
import { initializeGoogleTags, installConversionTracking, trackEvent } from "./seo/analytics";

// Import pages
import Home from "./pages/Home";
import Contactpage from "./pages/Contactpage";
import Aboutpage from "./pages/Aboutpage";
import Guaranteepage from "./pages/Guaranteepage";
import HoaLandscapingpage from "./pages/HoaLandscapingpage";
import Lawncarepage from "./pages/Lawncarepage";
import Hardscapingpage from "./pages/Hardscapingpage";
import Commericapage from "./pages/Commericapage";
import ThatchingandAerationpage from "./pages/ThatchingandAerationpage";
import Pressurewashingpage from "./pages/Pressurewashingpage";
import Blogpage from "./pages/Blogpage";
import BlogDetails from "./pages/BlogDetails";
import Irrigationpage from "./pages/Irrigationpage";
import Turfpage from "./pages/Turfpage";
import Zodpage from "./pages/Zodpage";
import Landscapingdesignpage from "./pages/Landscapingdesignpage";
import NotFoundpage from "./pages/NotFoundpage";

initializeGoogleTags();

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ScrollToHashElement = () => {
  const location = useLocation();
  React.useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200);
      }
    }
  }, [location]);
  return null;
};

const PageViewTracker = () => {
  const location = useLocation();

  React.useEffect(() => {
    trackEvent("page_view", {
      page_location: window.location.href,
      page_path: location.pathname + location.search,
    });
  }, [location]);

  React.useEffect(() => installConversionTracking(), []);

  return null;
};

const App = () => {
  return (
    <>
      <ScrollToTop />
      <ScrollToHashElement />
      <RouteSeo />
      <PageViewTracker />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about/who-we-are" element={<Aboutpage />} />
        <Route path="/contact" element={<Contactpage />} />
        <Route path="/about/our-guarantees" element={<Guaranteepage />} />
        <Route path="/services/hoa-maintenance" element={<HoaLandscapingpage />} />
        <Route path="/services/residential-maintenance" element={<Lawncarepage />} />
        <Route path="/services/hardscaping" element={<Hardscapingpage />} />
        <Route path="/services/commercial-maintenance" element={<Commericapage />} />
        <Route path="/services/lawn-recovery-package" element={<ThatchingandAerationpage />} />
        <Route path="/services/pressure-washing" element={<Pressurewashingpage />} />
        <Route path="/services/irrigation" element={<Irrigationpage />} />
        <Route path="/services/turf-installation" element={<Turfpage />} />
        <Route path="/services/sod-installation" element={<Zodpage />} />
        <Route path="/Landscapingdesign" element={<Landscapingdesignpage />} />
        <Route path="/blog" element={<Blogpage />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        <Route path="*" element={<NotFoundpage />} />
      </Routes>
    </>
  );
};

export default App;
